export const GET_CLEANING_TASK_COMPLETION_REQUEST =
  'GET_CLEANING_TASK_COMPLETION_REQUEST';
export const GET_CLEANING_TASK_COMPLETION_SUCCESS =
  'GET_CLEANING_TASK_COMPLETION_SUCCESS';
export const GET_CLEANING_TASK_COMPLETION_FAIL =
  'GET_CLEANING_TASK_COMPLETION_FAIL';
